// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"316835ca","496":"14dd2094","703":"1a4a175f"}[chunkId] + ".chunk.js";
};